import { DolanFonts } from '@sapappgyver/appgyver-descriptors/lib/dolan/v4';
import { defaultFonts } from '../../modules/fonts';

export default function getKnownFontVariantsByFamily(fontFamily: string, dolanFonts?: DolanFonts) {
  const fonts = defaultFonts.filter((font) => font.font_family === fontFamily);
  if (fonts.length) {
    return fonts;
  }
  return (dolanFonts || []).filter((font) => font.font_family === fontFamily);
}
